import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as constants from '../common/constants';
import * as JspUtil from '../common/JspUtil';
import { IceIcon, PageContainer } from '../components';
import * as actions from './actionCreators';
import { useJspVariables, useDebugRender } from '../hooks';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const stripedTableBodySx = {
    '& tr:nth-of-type(even)': { backgroundColor: 'action.hover' },
};
const PageExistingSessions = () => {
    useDebugRender('PageExistingSessions');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { launcher, panelStyle, jspVariables } = useJspVariables();
    const { jspSessions, jspSelectedUser, jspUserId } = jspVariables;

    let sessions = [];
    let sessionPrompt = 'You already have application session(s). Do you want to continue with multiple sessions?';
    if (JspUtil.isValueAvailable(jspSessions)) {
        const sessionParams = JSON.parse(jspSessions);
        if (sessionParams) {
            sessionPrompt = sessionParams.prompt;
            sessions = sessionParams.sessions;
        }
    }

    const onContinueClick = () => {
        const selectedUser = JspUtil.isValueAvailable(jspSelectedUser) ? jspSelectedUser : '';
        navigate(constants.ROUTE_PAGE_AUTHENTICATED, {
            state: {
                selectedUser: selectedUser,
                checkSession: 'N',
                bypassProtectedRoute: true
            },
        });
    };

    const onCancelClick = () => {
        dispatch({ type: actions.AUTH_SESSION, data: { authenticatedUser: {} } });
        dispatch({ type: actions.TFA_STATE, data: { required: false } });
        dispatch({ type: actions.GLOBAL_ID_TRANSITION, data: actions.GLOBAL_ID_TRANSITION_CLEAR });
        dispatch({ type: 'USER_CONTACT_VERIFIED', data: false });
        dispatch({ type: 'USER_PROFILE', data: {} });
        dispatch({ type: actions.CONTINUE_WITH_APPID_CLICK, data: '' });
        dispatch(actions.logoutUserToken(jspUserId, false, true, 'N'));
        navigate(constants.ROUTE_PAGE_LOGIN);
    };

    return (
        <PageContainer id="PageExistingSessions" dataAutomationId="page_existing_sessions">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Typography fontWeight={500}>{sessionPrompt}</Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
                    <Table>
                        <TableHead sx={{ '& th': { fontWeight: 'bold' } }}>
                            <TableRow sx={{ backgroundColor: '#ececec' }}>
                                <TableCell>{JspUtil.getLabelFromJspVariables('label_ip_address')}</TableCell>
                                <TableCell align="center">{JspUtil.getLabelFromJspVariables('label_session_start')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={stripedTableBodySx}>
                            {sessions.length === 0 ?
                                <TableRow>
                                    <TableCell colSpan={2} align="center" sx={{ color: 'text.secondary', fontStyle: 'italic', py: 3 }}>
                                        {JspUtil.getLabelFromJspVariables('label_no_sessions_found')}
                                    </TableCell>
                                </TableRow>
                                :
                                sessions.map((row, i) => {
                                    if (row) {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell>{row.ip}</TableCell>
                                                <TableCell align="center">{(new Date(row.startTime)).toLocaleString()}</TableCell>
                                            </TableRow>
                                        );
                                    }
                                    return null;
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', pt: 2 }}>
                    <Button variant="outlined"
                        onClick={onCancelClick}
                        data-automation-id="existing_sessions_cancel_btn">
                        {JspUtil.getLabelFromJspVariables('action_cancel')}
                    </Button>
                    <Button variant="contained"
                        onClick={onContinueClick}
                        data-automation-id="existing_sessions_continue_btn">
                        {JspUtil.getLabelFromJspVariables('action_continue')}
                    </Button>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default PageExistingSessions;
